import React from 'react';

/**
 * Preview step body — two states:
 *   - generating (ready === false): spinner while the deep-insight agent works
 *   - ready (ready === true): report is in the chat; prompt the user to confirm
 */
const PreviewStep = ({ ready }) => {
  if (ready) {
    return (
      <div className="reports-preview-step reports-preview-step--ready">
        <p className="reports-preview-step-detail">
          Your report is ready in the chat. Review it, then confirm to schedule.
        </p>
      </div>
    );
  }
  return (
    <div className="reports-preview-step">
      <div className="reports-preview-spinner" aria-hidden="true" />
      <p>Generating this report may take up to 5 minutes. Thank you for your patience.</p>
    </div>
  );
};

export default PreviewStep;
